import React from "react";
import Progress8Svg from "../../../assets/svgicons/progress-bar/progress_bar_8.svg";

const Progress8 = (props) => {
  return <img src={Progress8Svg} alt="Progress 8" {...props} />;
};

export default Progress8;
